import { InjectionToken } from "@angular/core";
import { EnvSetupObject } from "icamppro-shared-components";

export const CMP_ENV_SETUP = new InjectionToken<EnvSetupObject>('ENV SETUP');